import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeviceFactory } from '../../../../device-factory/device-factory';

@Component({
	selector: 'app-daily-ah-battery-fleet-utilization',
	templateUrl: './daily-ah-battery-fleet-utilization.component.html',
	styleUrls: ['./daily-ah-battery-fleet-utilization.component.css']
})
export class DailyAhBatteryFleetUtilizationComponent {
	@Input() data: any = {};
	@Input() devices: any = {};

	@Input() toDate = new Date();
	@Input() fromDate = new Date(this.toDate.getTime() - 30 * 24 * 60 * 60 * 1000)
	@Input() selectedBatteryVoltage: string = 'all';
	@Input() selectedBatteryCapacity: string = 'all';
	@Input() selectedManufacturer: string = 'all';
	@Input() selectedBatteryVintage: string[] = ['all'];
	@Output() prepareParentFiltersOptions = new EventEmitter<{ batteryVoltagesOptions: any[], batteryCapacitiesOptions: any[], manufacturers: any[] }>();

	chartType = 'ah';

	chart = {
		firstChartTitle: this.translate.instant('utilization.daily_amp_hour_battery_fleet_utilization'),
		secondChartTitle: this.translate.instant('utilization.daily_percent_amp_hour_battery_fleet_utilization'),
		firstChartYAxeTitle: this.translate.instant('g.ahr'),
	}

	devicesType = [DeviceFactory.types.battlink, DeviceFactory.types.battlinkII, DeviceFactory.types.lithiumBattlink];

	constructor(
		private translate: TranslateService
	) {}

	prepareParentFiltersOptionsEmitter(event: { batteryVoltagesOptions: any[], batteryCapacitiesOptions: any[], truckManufacturers: any[] }) {
		this.prepareParentFiltersOptions.emit({ ...event, manufacturers: event.truckManufacturers });
	}
}
